import { ICommentProps } from "./Interfaces";
import { Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";

export default function Comment({
  commentDefaultValue = "",
  clear,
  onChange,
}: ICommentProps) {
  const [comment, setComment] = useState(commentDefaultValue);
  useEffect(() => {
    setComment(commentDefaultValue);
    onChange(comment);
  }, [clear]);
  return (
    <Row>
      <Col xs={2}>
        <label>Comments</label>
      </Col>
      <Col xs={6}>
        <textarea
          id="input-comment"
          value={comment}
          onChange={(e) => {
            const newComment = e.target.value;
            setComment(newComment);
            onChange(newComment);
          }}
          placeholder="Enter Comment"
          className="form-control max-height"
        />
      </Col>
    </Row>
  );
}
